// Import libs
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

// Import components
import { setLang } from '../Base/Actions/globalActions';
import Meta from '../Components/Globals/Meta/MetaController';

class LenspireView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      resizeId: 0,
      highestScroll: 0,
    };

    this.onScroll = this.onScroll.bind(this);
  }

  componentWillMount() {
    if (this.props.lang !== this.props.match.params.lang) {
      this.props.setLang(this.props.match.params.lang);
    }
    clearTimeout(this.state.resizeId);
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillReceiveProps(nextProps) {
    clearTimeout(this.state.resizeId);
    if (nextProps.match.params.lang !== this.props.lang) {
      this.props.setLang(nextProps.match.params.lang);
    }

    this.setState({
      highestScroll: 0,
    });
  }

  componentWillUnmount() {
    clearTimeout(this.state.resizeId);
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    clearTimeout(this.state.resizeId);
    this.setState({
      resizeId: setTimeout(() => {
        const scrollHeight = document.body.scrollHeight;
        if (this.node && !this.props.isLoading) {
          const bottom = this.node.scrollTop + this.node.clientHeight;
          if (bottom - scrollHeight < 1000 && this.state.highestScroll < scrollHeight) {
            this.props.onScroll();
            this.setState({
              highestScroll: scrollHeight,
            });
          }
        }
      }, 1000),
    });
  }

  render() {
    if (this.props.error === '404') {
      return (<Redirect to={`/${process.env.LENSPIRE_CHANNEL}/${this.props.lang}/404`} />);
    }

    return (
      <div
        className={this.props.className}
        ref={(node) => {
          this.node = node;
        }}
      >
        <Meta />
        {this.props.children}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    meta: state.globalsState.meta,
    error: state.globalsState.error,
    lang: state.globalsState.lang,
    isLoading: state.loaderState.isLoading,
  };
}

LenspireView.propTypes = {
  setLang: PropTypes.func.isRequired,
  match: PropTypes.shape(),
  error: PropTypes.string,
  lang: PropTypes.string,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  onScroll: PropTypes.func,
};

LenspireView.defaultProps = {
  tilesData: [
    {
      headline: '',
      subline: '',
      image: {},
    },
  ],
  error: '',
  match: {},
  lang: 'en',
  className: '',
  children: null,
  isLoading: true,
  onScroll: () => {
  },
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setLang }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LenspireView));



// WEBPACK FOOTER //
// ./frontend/js/Views/LenspireView.jsx